
import * as $ from 'jquery';
(window as any).$ = $;
(window as any).jQuery = $;

import 'zone.js';